"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uploadProgressbar = void 0;
exports.uploadProgressbar = [function () {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'modules/upload/directives/uploadprogressbar.tpl.html',
            scope: {
                file: '='
            },
            link: function (scope, element, attrs) {
                scope.getProgressType = function () {
                    if (scope.file.error) {
                        return 'danger';
                    }
                    if (scope.file.percentageComplete === 100)
                        return 'success';
                    return null;
                };
            }
        };
    }];
